import invoiceApplication from './invoiceApplication'
import bill from './bill'

export default {
  namespaced: true,
  modules: {
    invoiceApplication,
    bill,
  },
}
